export default __webpack_public_path__ + "static/media/ic_outline-lock-person.21110cc8.svg";